import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { inquiries } from '@api/inquiries';
import { IInquiriesSearchProps, IInquiriesTableData } from '@interfaces/inquiries';

import { buildInquiryListPayload } from './utils';

export const handleGetInquiryList = createAsyncThunk<
  AxiosResponse<IInquiriesTableData>,
  IInquiriesSearchProps
>('getInquiryList', props => inquiries(buildInquiryListPayload(props)));
